import CreateButton from '@fd/frontend/components/ProxyPoolCreatePage/CreateButton';
import Footer from '@fd/frontend/components/ui/Footer';

export default function CreatePoolFooter() {
  return (
    <Footer>
      <CreateButton className="w-full" />
    </Footer>
  );
}
